import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=f6ccf6fc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ccf6fc')) {
      api.createRecord('f6ccf6fc', component.options)
    } else {
      api.reload('f6ccf6fc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=f6ccf6fc&", function () {
      api.rerender('f6ccf6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fjMb4BJJFnmk/JS/offershelp.vue"
export default component.exports